export default __webpack_public_path__ + "de11b2587612e8473f897dd9c3fff0c1.png";